import { ThemeConfig } from "antd/es/config-provider"
import frannyTheme from "./franny.theme"

const theme: ThemeConfig = frannyTheme

export default theme
